import { ConfigOption } from '@ngx-formly/core';
import { FormlyFieldCheckbox } from './checkbox.type';

export function withFormlyCheckbox(): ConfigOption {
  return {
    types: [
      {
        name: 'checkbox',
        component: FormlyFieldCheckbox,
        wrappers: []
      }
    ]
  };
}